import React from 'react';
import { Tooltip } from 'reactstrap';
import { connect } from 'react-redux';
import { withLocalize } from 'react-localize-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class CustomTooltip extends React.Component {
    mounted = false;
    state = { tooltipOpen: false };

    render() {
        return (
            <span>
                {!this.props.hideIcon && <span href="#" id={this.props.id || "tooltip"}>
                    <FontAwesomeIcon icon="info-circle" />
                </span>}
                <Tooltip
                    placement={this.props.placement || "top"}
                    isOpen={this.state.tooltipOpen}
                    delay={{ ...this.props.delay || {}, hide: 0, show: 0 }}
                    target={this.props.id || "tooltip"}
                    toggle={this.toggle}
                    innerClassName={this.props.innerClassName == null ? "bb-tooltip-inner" : this.props.innerClassName}
                >
                    {this.props.text}
                </Tooltip>
                {this.props.hideIcon &&
                    <span href="#" id={this.props.id || "tooltip"}>
                        {this.props.children}
                    </span>
                }
            </span>
        );
    }

    componentDidMount() {
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    toggle = () => {
        if (this.mounted)
            this.setState({ tooltipOpen: !this.state.tooltipOpen });
    }
}
export default withLocalize(connect()(CustomTooltip));